import type { RouteObject } from 'react-router-dom';

/** Views 24 (inbox) and 25 (received detail). They are the whole flow: they go together. */
export const inboundRoutes: RouteObject[] = [
  {
    path: 'inbound',
    lazy: () =>
      import('@/routes/pages/InboundListPage').then((m) => ({
        Component: m.InboundListPage,
      })),
  },
  {
    path: 'inbound/:id',
    lazy: () =>
      import('@/routes/pages/InboundDetailPage').then((m) => ({
        Component: m.InboundDetailPage,
      })),
  },
];
